import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, requireSuperadmin = false }) => {
    const { user, isAuthLoading } = useContext(AuthContext);

    if (isAuthLoading) {
        return <div className="loading-state">Loading...</div>;
    }

    if (!user) {
        return <Navigate to="/login" />;
    }

    if (requireSuperadmin && !user.isSuperadmin) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
